import React, { useEffect, useRef } from 'react';
import { allCommands } from '../data/cyberCommands';

const MatrixRain = ({ opacity = 0.06 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();

    // Mix of classic matrix chars AND real command fragments
    const matrixChars = 'アイウエオカキクケコサシスセソタチツテト01234567890xABCDEF{}[]<>/\\|;:~`!@#$%^&*()';

    // Extract short fragments from real commands for the rain
    const cmdFragments = allCommands.flatMap((cmd) => {
      const parts = cmd.split(/\s+/);
      return parts.filter((p) => p.length >= 3 && p.length <= 15);
    });

    const fontSize = 13;
    const columns = Math.floor(canvas.width / fontSize);
    const drops = Array(columns).fill(0).map(() => Math.floor(Math.random() * -50));

    // Some columns show command fragments instead of single chars
    const columnModes = Array(columns).fill(0).map(() => Math.random());

    let animId;
    const draw = () => {
      ctx.fillStyle = 'rgba(10, 10, 15, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `${fontSize}px "JetBrains Mono", monospace`;

      for (let i = 0; i < drops.length; i++) {
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        let char;

        // 30% of columns show real command fragments, 70% show matrix chars
        if (columnModes[i] > 0.7 && Math.random() > 0.92) {
          // Show a real command fragment
          char = cmdFragments[Math.floor(Math.random() * cmdFragments.length)];
          ctx.fillStyle = 'rgba(0, 212, 255, 0.6)';
          ctx.font = `${fontSize - 2}px "JetBrains Mono", monospace`;
          ctx.fillText(char, x, y);
          ctx.font = `${fontSize}px "JetBrains Mono", monospace`;
        } else {
          char = matrixChars[Math.floor(Math.random() * matrixChars.length)];

          // Occasional bright white "head" character
          if (Math.random() > 0.97) {
            ctx.fillStyle = '#ffffff';
          } else if (Math.random() > 0.94) {
            ctx.fillStyle = 'rgba(0, 212, 255, 0.7)';
          } else {
            const brightness = Math.random() * 0.4 + 0.3;
            ctx.fillStyle = `rgba(0, 255, 65, ${brightness})`;
          }
          ctx.fillText(char, x, y);
        }

        if (y > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
          // Occasionally switch column mode
          if (Math.random() > 0.8) columnModes[i] = Math.random();
        }
        drops[i]++;
      }

      animId = requestAnimationFrame(draw);
    };

    draw();
    window.addEventListener('resize', resize);

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none"
      style={{ opacity, zIndex: 0 }}
    />
  );
};

export default MatrixRain;
